import {
  SKILL_LIBRARY_MAX,
  SKILL_LIBRARY_UNLOCKED_DEFAULT,
} from "@/character/skills/constants";
import type { HomeEconomy } from "@/home/economy";

export function skillLibrarySlotsUnlocked(economy: HomeEconomy): number {
  return economy.skillLibrarySlotsUnlocked;
}

export type SkillLibraryGateResult = { ok: true } | { ok: false; reason: string };

export function canAddSkillToLibrary(
  librarySize: number,
  economy: HomeEconomy,
): SkillLibraryGateResult {
  const cap = skillLibrarySlotsUnlocked(economy);
  if (librarySize >= cap) {
    if (cap >= SKILL_LIBRARY_MAX) {
      return {
        ok: false,
        reason: `คลังสกิลเต็ม (${cap}/${SKILL_LIBRARY_MAX}) · ซื้อช่องคลังที่ร้าน Cash`,
      };
    }
    return {
      ok: false,
      reason: `คลังสกิลเต็ม (${librarySize}/${cap}) · ลบสกิลหรือซื้อช่องคลังที่ร้าน Cash`,
    };
  }
  if (economy.skillCreateCards < 1) {
    return { ok: false, reason: "ไม่มีบัตรสร้างสกิล · ซื้อที่ร้าน Cash" };
  }
  return { ok: true };
}

export function consumeSkillCreateCard(economy: HomeEconomy): HomeEconomy {
  return {
    ...economy,
    skillCreateCards: Math.max(0, economy.skillCreateCards - 1),
  };
}

/** Grandfather saves that already have more skills than the default library cap. */
export function alignSkillLibrarySlotsWithInventory(
  libraryLength: number,
  economy: HomeEconomy,
): HomeEconomy {
  const need = Math.min(
    SKILL_LIBRARY_MAX,
    Math.max(SKILL_LIBRARY_UNLOCKED_DEFAULT, libraryLength),
  );
  const unlocked = skillLibrarySlotsUnlocked(economy);
  if (unlocked >= need) return economy;
  return { ...economy, skillLibrarySlotsUnlocked: need };
}
